import Service from './Service';

const DOCUMENTS_SETDATA = 'DOCUMENTS_SETDATA';
const reducerName = 'documents';

const initialState = {
    documents: []
};

const reducer = (state = initialState, action) => {
    const {type, payload} = action;

    switch (type) {
        case DOCUMENTS_SETDATA:
            return {
                ...state,
                documents: payload
            };
    }
    
    return state;
};

class DocumentService extends Service {
    constructor() {
        super();

        if (!DocumentService.instance) {
            DocumentService.instance = this;
        }
        return DocumentService.instance;
    }

    getReducerName() {
        return reducerName;
    }

    getReducer() {
        return reducer;
    }

    setData(data) {
        this.store.dispatch({
            type: DOCUMENTS_SETDATA,
            payload: data
        });
    }
}

export default new DocumentService();
